import { Controller } from 'stimulus'
import axios from 'axios';
import { template } from 'lodash';

export default class extends Controller {
  static targets = ['isChecked']

  connect() {
  window.lastStimulus = this;
  // console.log("Controller connected:", this);
  requestAnimationFrame(() => {
  // console.log("After DOM settled - has target?", this.hasIsCheckedTarget);
  // console.log(this.isCheckedTarget)
});
}

  addIt() {
  const element = event.target;
  const branchId = element.id
  const url = `/api/v1/branches/${branchId}`;
  this.requesting = true;

  axios.patch(url, { active: element.checked }, {
  headers: { Accept: 'application/json' }
  }).then((response) => {
  this.requesting = false;
  // console.log("Raw response:", response.data);  // 👈 Check this first
  console.log("Response back");
  // response.data.map((result) => {
  // });
})
}
}